import LocalApa from './LocalApa';

class LocalConfig extends LocalApa {}

export default LocalConfig;



// WEBPACK FOOTER //
// ./src/requests/apa/local/LocalConfig.js